"use client";

import Image from "next/image";

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography,
} from "@artha/ui";

type VpnRestrictionModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const VpnRestrictionModal = ({
  isOpen,
  onClose,
}: VpnRestrictionModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      className="mx-0 border border-black p-6 !animate-none"
    >
      <ModalHeader>
        <Image
          src="/images/rejection-illustration.png"
          alt=""
          width={80}
          height={80}
          className="mb-4 object-contain"
        />
        <Typography
          variant="lead"
          className="text-center text-lg font-semibold leading-relaxed text-[#344054]"
        >
          VPN Connection Detected
        </Typography>
      </ModalHeader>

      <ModalBody>
        <Typography
          variant="small"
          className="text-sm leading-relaxed text-[#667085] text-center"
        >
          You are connected to a VPN. We do not allow job applications while using a VPN. Please disable your VPN to continue.
        </Typography>
      </ModalBody>
    </Modal>
  );
};
